const hot = [
  {
    tag: "综艺",
    tagClass: "bg-primary-100 text-primary-700",
    title: "新一季音乐竞演综艺首播成绩亮眼",
    excerpt:
      "多组选手的初舞台表现引发网友热议，相关话题一度登上热搜，节目里的翻唱片段在各平台快速传播。",
    heat: "热议 12.8w",
    time: "2 小时前",
  },
  {
    tag: "影视",
    tagClass: "bg-accent-100 text-accent-800",
    title: "热播剧大结局剧情走向全梳理",
    excerpt:
      "随着大结局临近，观众对角色命运与原著的改编分歧讨论热烈，官方放出的预告进一步点燃期待。",
    heat: "热议 8.6w",
    time: "4 小时前",
  },
  {
    tag: "音乐",
    tagClass: "bg-secondary-100 text-secondary-800",
    title: "人气歌手新专辑多平台同步上线",
    excerpt:
      "新专辑主打曲 MV 上线后播放量快速增长，音乐平台评论区掀起一波创作与翻唱的热潮。",
    heat: "热议 6.2w",
    time: "6 小时前",
  },
  {
    tag: "直播",
    tagClass: "bg-primary-100 text-primary-700",
    title: "头部主播公益助农直播圆满落幕",
    excerpt:
      "直播过程穿插才艺表演与产品讲解，观众热情互动，多款助农产品短时间内售罄，氛围温暖。",
    heat: "热议 5.4w",
    time: "9 小时前",
  },
];

export default function HotTopics() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end md:mb-14">
          <div>
            <span className="inline-flex items-center rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700">
              <i className="ri-fire-line mr-1"></i>热门瓜事
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              最近大家都在吃什么瓜？
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              精选当前热度较高的娱乐话题，内容实时更新，理性吃瓜，不信谣不传谣。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {hot.map((item, idx) => (
            <article
              key={item.title}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100/60 p-6 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center gap-3">
                <span
                  className={`inline-flex h-8 w-8 items-center justify-center rounded-lg font-heading text-sm font-black text-foreground-800 ${item.tagClass}`}
                >
                  {idx + 1}
                </span>
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${item.tagClass}`}>{item.tag}</span>
              </div>
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-700">{item.excerpt}</p>
              <div className="mt-auto flex items-center gap-4 pt-2 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-line text-primary-500"></i>
                  {item.heat}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {item.time}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}